import { render, staticRenderFns } from "./InvestmentSection.vue?vue&type=template&id=a8188c88&scoped=true"
import script from "./InvestmentSection.vue?vue&type=script&lang=ts"
export * from "./InvestmentSection.vue?vue&type=script&lang=ts"
import style0 from "./InvestmentSection.vue?vue&type=style&index=0&id=a8188c88&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8188c88",
  null
  
)

export default component.exports